export default __webpack_public_path__ + "static/media/english-to-swedish-screenshot-04.c86a78ea.png";